<div *ngIf="!loggedIn">
  <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
</div>
<div *ngIf="loggedIn">
  <mat-icon>done</mat-icon>
</div>
